import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { AdminService } from '@app/services/admin.service';
import { Constants } from '@app/shared-module/constants';
import { GlobalResponse } from '@app/shared-module/models';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { ActivateDoctorSubscriptionDialogComponent } from '../activate-doctor-subscription/activate-doctor-subscription.component';

@Component({
  selector: 'app-view-doctor-subscription',
  templateUrl: './view-doctor-subscription.component.html',
  styleUrls: ['./view-doctor-subscription.component.css']
})
export class ViewDoctorSubscriptionDialogComponent implements OnInit {
  public headerTitle: string;
  subscriptionData: any;
  doctor_id: string;
  activated = false;
  deactivated = false;
  @BlockUI() blockUI: NgBlockUI;
  constructor(
    public dialogRef: MatDialogRef<ViewDoctorSubscriptionDialogComponent>,
    public dialog: MatDialog,
    public toastr: ToastrService,
    private service: AdminService
  ) { }

  ngOnInit() {
    if (this.subscriptionData.status === 'ACTIVE') {
      this.deactivated = true;
    } else {
      this.activated = true;
    }
  }

  activateSubscription() {
    const activateSubscription = this.dialog.open(ActivateDoctorSubscriptionDialogComponent, {
      disableClose: false
    });
    activateSubscription.componentInstance.headerTitle = 'Activate Subscription';
    activateSubscription.componentInstance.subscriptionData = this.subscriptionData;
    activateSubscription.componentInstance.doctor_id = this.doctor_id;
    activateSubscription.afterClosed().subscribe(result => {
      if (result) {
        this.dialogRef.close(true);
      }
    });
  }

  deactivateSubscription() {
    this.blockUI.start();
    this.service.deactivateSubscription(this.subscriptionData, this.doctor_id).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        this.dialogRef.close(res.result);
      }
    },
      (error: any) => {
        this.blockUI.stop();
        this.toastr.error(error);
      });
  }

}
